import request from '@/utils/request'
import { v2Host } from '@/config/host'

const cookUrl = (name) => `${v2Host}/dashboard/overview/${name}`

export function getPoints() {
  return request({
    url: cookUrl('point'),
    method: 'get'
  })
}

export function getPlayable() {
  return request({
    url: cookUrl('playable'),
    method: 'get'
  })
}

export function getPlaysmart() {
  return request({
    url: cookUrl('playsmart'),
    method: 'get'
  })
}